import React, {useMemo} from "react";
import {FaCheck} from "react-icons/fa";
import {FaTriangleExclamation} from "react-icons/fa6";
import ReferenceImportModal from "../../../../../components/reference-import-modal/reference-import-modal.jsx";
import placeService from "../../../../../services/web/place-service.js";

const PlaceImport = ({open, setOpen, refetch, setIsLoading}) => {
    const columnDefs = useMemo(() => {
        const reasonLabels = {
            "place.import.name.empty": "Nome vazio.",
            "place.import.city.empty": "Município vazio.",
            "place.import.city.invalid": "Município deve estar no formato Cidade - UF.",
            "place.import.name.duplicated": "Nome repetido na planilha.",
            "place.import.name.already.used": "Local já cadastrado.",
            "place.import.type.invalid": "Tipo de local não cadastrado.",
            "place.import.cnpj.invalid": "CNPJ inválido.",
            "place.import.phone.invalid": "Telefone inválido.",
            "place.import.zipcode.invalid": "CEP inválido.",
            "place.import.coordinates.incomplete": "Latitude e longitude devem ser informadas juntas.",
            "place.import.coordinates.invalid": "Latitude ou longitude inválida.",
            "place.import.status.invalid": "Status inválido."
        };

        return [
            {headerName: "", field: "status", width: 56, sortable: false, cellRenderer: ({value}) => <div className="flex h-full items-center justify-center">{value === "NEW" ? <FaCheck color="#219453"/> : <FaTriangleExclamation color="#ed5565"/>}</div>},
            {headerName: "Linha", field: "row", width: 80},
            {headerName: "Nome", field: "name", flex: 1, minWidth: 180},
            {headerName: "Município - UF", field: "cityState", flex: 1, minWidth: 170},
            {headerName: "Tipo", field: "type", flex: 1, minWidth: 150},
            {headerName: "Status", field: "status", width: 120, valueFormatter: ({value}) => value === "NEW" ? "Novo" : "Ignorado"},
            {headerName: "Motivo", field: "reason", flex: 1, minWidth: 240, valueFormatter: ({value}) => reasonLabels[value] ?? value}
        ];
    }, []);

    const getPreviewErrorMessage = (error) => {
        const messages = {
            "place.import.file.structure.invalid": "A planilha de importação não corresponde ao formato exigido. Utilize o modelo disponibilizado.",
            "place.import.file.type.invalid": "Selecione um arquivo Excel válido.",
            "place.import.file.invalid": "O arquivo Excel é inválido ou não pode ser lido.",
            "place.import.file.size.invalid": "O arquivo excede o limite de 5 MB.",
            "place.import.rows.limit.exceeded": "A planilha excede o limite de 5.000 linhas."
        };

        return messages[error.response?.data?.message] ?? "Não foi possível gerar a prévia da importação.";
    };

    const downloadTemplate = () => placeService.importTemplate().then((fileData) => {
        const url = URL.createObjectURL(fileData);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Modelo de importação Locais.xlsx";
        link.click();
        URL.revokeObjectURL(url);
    });

    const buildPayload = (rows) => ({places: rows.filter(({status}) => status === "NEW").map(({place}) => place)});

    return <ReferenceImportModal
        open={open}
        setOpen={setOpen}
        refetch={refetch}
        setIsLoading={setIsLoading}
        title="Importação de locais"
        columnDefs={columnDefs}
        previewImport={placeService.importPreview}
        createImport={placeService.createImport}
        buildPayload={buildPayload}
        downloadTemplate={downloadTemplate}
        getPreviewErrorMessage={getPreviewErrorMessage}
        successMessage={(created, ignored) => `Importados: ${created}<br>Não importados: ${ignored}`}
        successTitle="Local pré-cadastrado"
        importErrorMessage="Não foi possível importar os locais."
        templateErrorMessage="Não foi possível baixar o modelo de importação."
    />;
};

export default PlaceImport;
